import { useEffect, useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { useBlocker } from 'react-router-dom';

import {
  ROUTE_PAY_AND_POST,
  ROUTE_PAY_AND_POST_V2,
  ROUTE_SUCCESS,
} from 'src/app/shared/constants/routes';
import {
  FEATURE_CART_AND_PAY_AND_POST_V2,
  useFeatureToggleData,
} from 'src/app/shared/featureToggle';
import { useLocalisedRoutes } from 'src/app/v1/views/hooks/useLocalisedRoutes';
import type { AppState } from 'src/types/appState';

export const useNavigationBlockerCreateFlow = () => {
  const { draftId } = useSelector(
    (state: AppState) => ({
      draftId: state.session.draftId,
    }),
    shallowEqual,
  );

  const [shouldNavigateToDashboard, setShouldNavigateToDashboard] =
    useState(false);

  const { goToRoute, redirectToDashboard } = useLocalisedRoutes();
  const isCartAndPayAndPostPageV2FeatureEnabled = useFeatureToggleData(
    FEATURE_CART_AND_PAY_AND_POST_V2,
  );

  useEffect(() => {
    if (shouldNavigateToDashboard) {
      redirectToDashboard();
    }
  }, [shouldNavigateToDashboard, redirectToDashboard]);

  // NOTE: only one useBlocker will get executed.
  // So combine all requirements under one useBlocker.
  useBlocker(({ currentLocation, nextLocation }) => {
    // ====== Requirement 1  ======
    // Redirect hirers from PayAndPost page v1 to v2
    if (
      nextLocation.pathname.endsWith(ROUTE_PAY_AND_POST) &&
      Boolean(isCartAndPayAndPostPageV2FeatureEnabled)
    ) {
      goToRoute(`${ROUTE_PAY_AND_POST_V2}?draftid=${draftId}`);
      return true;
    }

    // ====== Requirement 2  ======
    // Redirect hirers to Dashboard if they try to navigate backwards from Success page
    if (
      currentLocation.pathname.includes(ROUTE_SUCCESS) &&
      (nextLocation.pathname.includes(ROUTE_PAY_AND_POST) ||
        nextLocation.pathname.includes(ROUTE_PAY_AND_POST_V2))
    ) {
      setShouldNavigateToDashboard(true);
      return true;
    }

    return false;
  });
};
